import {ReactElement} from 'react'
import {useController, useFormContext} from 'react-hook-form'
import {isEqual} from 'lodash'
import {
  MultiTagFilteringField,
  MultiTagFilteringFieldProps,
  takeNewMultiTagValues,
} from 'jbc-front/components/SearchForm'
import {Row, Header, Body} from './AdditionalSearchField'

type MultiTagFilteringFieldRowProps<T> = Omit<MultiTagFilteringFieldProps<T>, 'input'> & {
  name: string
  onChange?: (value: T[], prevValue: T[]) => void
  shouldUnregister?: boolean
}

export const MultiTagFilteringFieldRow = <T,>({
  name,
  header,
  list,
  takeNewValuesFunc = takeNewMultiTagValues,
  onChange,
  shouldUnregister = false,
  ...rest
}: MultiTagFilteringFieldRowProps<T>): ReactElement => {
  const {control} = useFormContext()
  const field = useController({name, control, shouldUnregister})
  return (
    <Row>
      <Header>{header}</Header>
      <Body>
        <MultiTagFilteringField
          input={{
            value: field.field.value || [],
            onChange: (_v) => {
              const v = _v as unknown as T[] // FIXME: jbc-front側の型定義が間違っている
              field.field.onChange(v)
              if (onChange && !isEqual(v, field.field.value)) {
                onChange(v, field.field.value)
              }
            },
            onBlur: field.field.onBlur,
          }}
          header={header}
          list={list}
          takeNewValuesFunc={takeNewValuesFunc}
          {...rest}
        />
      </Body>
    </Row>
  )
}
